import React from 'react';
import { Text } from 'rebass';

interface PaginationButtonProps {
  buttonHandler: VoidFunction;
  label: string;
}

const PaginationButton: React.FC<PaginationButtonProps> = ({ buttonHandler, label }) => (
  <Text css={{ cursor: 'pointer' }} onClick={buttonHandler}>
    {label}
  </Text>
);

export default PaginationButton;
